import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { taskmanagementschema } from "../../../../../JsonData/CreateTaskConfig";
import DynamicTabs from "../../../Common/Tabs/Tabs";
import { toast, ToastContainer } from "react-toastify";

import FormHandler from "../../../Common/Form/FormHandler/FormHandler";

import useFormPersist from "react-hook-form-persist";

import { ExecuteSopsConfig } from "../../ExecuteSopsForm/ExecuteSopsConfig";

import "./SopsInstanceForm.css";

import { useTranslation } from "react-i18next";

import {
  getData,
  postDataWithBody,
  putDataWithBody,
  editData,
} from "../../../../../Services/Services";

import {
  getTaskConfigsURL,
  getAllActiveRole,
  createTaskURL,
  findTaskById,
  getTaskListURL,
  updateTaskURL,
  CloseSopTask,
  getSopInstanceResourceById,
  getSopMasterData,
} from "../../../../../Services/EndPoints";

import Loader from "react-spinner-loader";
import { downloadFile } from "../../../../../Components/UiComponents/utils";
import { PaperClipIcon } from "../../../../../Components/IconComponents";
import { useKeycloak } from "@react-keycloak/web";
import TaskModalWithCommentSop from "../../../../../Components/UiComponents/TaskModalWithComment/TaskModalWithCommentSop";
import TaskModalWithCommentSopCancel from "../../../../../Components/UiComponents/TaskModalWithComment/TaskModalWithCommentSopCancel";
import ConfirmpopupSop from "../../../Common/ConfirmPopup/ConfirmpopupSop";
//Task Management

const SopsInstanceForm = (props) => {
  const [CreateTaskConfig, setCreateTaskConfig] = useState(ExecuteSopsConfig);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [taskConfigs, setTaskConfigs] = useState([]);
  const [setViewTask, setViewTaskById] = useState(null);
  const [roleArr, setRoleArr] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPop, setShowPop] = React.useState(false);
  const [showConfirmPopup, setshowConfirmPopup] = React.useState(false);
  const [resourcesData, setResourcesData] = useState(""); // New state for resources
  const [fullResourcesData, setFullResourcesData] = useState([]);
  const [incidentId, setIncidentId] = useState(null);

  const { state } = useLocation();
  // Get data from state or session storage
  const [formData, setFormData] = useState(null);
  const [id, setId] = useState(null);
  const [mediapath, setMediapath] = useState(null);

  const { keycloak } = useKeycloak();

  // Session storage key
  const SESSION_STORAGE_KEY = "sops_instance_form_data";

  useEffect(() => {
    // Retrieve data - first check state, then session storage
    let stateData = state?.data;

    // If state data exists, save it to session storage
    if (stateData) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(stateData));
      setFormData(stateData);
      setId(stateData.id);
      setMediapath(stateData.media_file_path);
    }
    // If no state data, try to get from session storage
    else {
      const storedData = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setFormData(parsedData);
        setId(parsedData.id);
        setMediapath(parsedData.media_file_path);
      } else {
        // No data in state or session storage, redirect to list view
        toast.error("No SOP instance data found. Redirecting to view page.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setTimeout(() => navigate("../viewsops-instance"), 2000);
      }
    }
  }, [state, navigate]);

  // New function to fetch master user task list and extract incident_id
  const fetchMasterUserTaskList = async (sopId) => {
    try {
      const masterUserTaskListResponse = await getData(getSopMasterData + sopId);
      const masterUserTaskList = masterUserTaskListResponse || [];

      // Extract incident_id from the first item in the array
      if (masterUserTaskList.length > 0 && masterUserTaskList[0].incident_id) {
        setIncidentId(masterUserTaskList[0].incident_id);
        console.log("Incident ID:", masterUserTaskList[0].incident_id);
      } else {
        console.warn("No incident_id found in master user task list");
        setIncidentId(null);
      }
    } catch (error) {
      console.error("Error fetching master user task list:", error);
      setIncidentId(null);
    }
  };

  // New function to fetch resources
  const fetchResources = async (sopId) => {
    try {
      const getResourcesToDeploy = await getData(`${getSopInstanceResourceById}${sopId}`);
      if (getResourcesToDeploy && getResourcesToDeploy.length > 0) {
        setFullResourcesData(getResourcesToDeploy);
        const resourceNames = getResourcesToDeploy.map(resource => `${resource.name} (${resource.agency_name})`).join(', ');
        setResourcesData(resourceNames);
      } else {
        setFullResourcesData([]);
        setResourcesData("NA");
      }
    } catch (error) {
      console.error("Error fetching resources:", error);
      setFullResourcesData([]);
      setResourcesData("NA");
    }
  };

  useEffect(() => {
    if (id) {
      fetchResources(id);
      fetchMasterUserTaskList(id);
    }
  }, [id]);

  console.log(formData, "newdata");
  console.log(id, "SOP INSTANCE ID")
  let downloadAttachmentURL =
    process.env.REACT_APP_APP_SERVER_ADDRESS +
    "/" +
    process.env.REACT_APP_CORE_CONTEXT_PATH_NAME +
    "/download/download_attachments/?directoryPath=" +
    mediapath +
    "&fileName=Tasks.zip";

  console.log(formData, "checking the data");

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(taskmanagementschema[activeTab]),
    mode: "all",
  });

  const getLoggedInuserName = () => {
    return keycloak.idTokenParsed.email;
  };

  useEffect(() => {
    if (formData) {
      getInitData();
    }
  }, [formData]);

  // GET
  async function getViewData() {
    var getViewData = await getData(getTaskListURL);
    // setViewTask(getViewData);
    if (id) {
      await populateViewFormFrEdit(id);
    }
  }

  //EDIT
  async function populateViewFormFrEdit(id) {
    var viewData = await postDataWithBody(findTaskById, [id], {});
    viewData = viewData[0];
    setViewTaskById(viewData);
    reset(viewData);
  }

  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        {taskConfigs.length > 0 && roleArr.length > 1 && (
          <FormHandler
            register={register}
            errors={errors}
            fields={fields}
            control={control}
            editId={id}
            columns={2}
            getValues={getValues}
            fileObjs={fileObjs}
            setFileObjs={setFileObjs}
          />
        )}
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    setLoader(true);
    setIsSubmitting(true); // Disable the button
    e.preventDefault();

    const formData = new FormData();

    // Append form data
    Object.entries(data).forEach(([key, value]) => {
      if (key === "task_media_file") {
        if (value && value.length > 0) {
          value.forEach((file) => formData.append(key, file));
        }
      } else {
        formData.append(key, value);
      }
    });

    // Ensure 'status' and 'id' are appended only once
    if (!formData.has("status")) {
      formData.append("status", true);
    }

    if (id && !formData.has("id")) {
      formData.append("id", id);
    }

    console.log(formData, "formData");

    const headers = { "Content-Type": "multipart/form-data" };
    let res;

    // Conditional API call
    if (id) {
      res = await putDataWithBody(updateTaskURL, formData, headers);
    } else {
      res = await postDataWithBody(createTaskURL, formData, headers);
    }

    // Handle response
    if (res.status === "success") {
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      navigate("/planning/view-task");
    } else {
      toast.error(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
    }

    setIsSubmitting(false); // Re-enable the button
    setLoader(false);
  };

  async function getInitData() {
    setLoader(true);
    await getTaskConfigs();
    await fetchAllRoles();
    // await getTaskStatus();
    await getViewData();
    setLoader(false);
    if (id) {
      populateViewFormFrEdit(id);
    }
  }

  async function fetchAllRoles() {
    let rolearr = await getData(getAllActiveRole);
    setRoleArr(rolearr);
    let roleFrDropdown = [];
    for (let role in rolearr) {
      roleFrDropdown.push({
        label: rolearr[role].name,
        value: rolearr[role].id,
      });
    }
    CreateTaskConfig[0].fields[2]["options"] = roleFrDropdown;
    setCreateTaskConfig(CreateTaskConfig);
  }

  async function getTaskConfigs() {
    let res = await postDataWithBody(
      getTaskConfigsURL,
      ["TSK_PRIOR", "INCDNT_CAT", "TSK_STAT", "TSK_TYP"],
      {}
    );
    setTaskConfigs(res);
    let config_type = {};
    for (let config in res) {
      if (config_type[res[config].category_name]) {
        config_type[res[config].category_name].push({
          label: res[config].value,
          value: res[config].id,
        });
      } else {
        config_type[res[config].category_name] = [
          { label: res[config].value, value: res[config].id },
        ];
      }
    }
    //alert(config_type["INCDNT_CAT"])
    CreateTaskConfig[0].fields[0]["options"] = config_type["INCDNT_CAT"];
    CreateTaskConfig[0].fields[2]["options"] = config_type["TSK_PRIOR"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_STAT"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_TYP"];
    setCreateTaskConfig(CreateTaskConfig);
  }

  const handleclick = () => {
    navigate("../viewsops-instance");
  };

  const handleClickClose = () => {
    setshowConfirmPopup(true);
  };

  const handleclickCancel = async () => {
    setShowPop(true);
  };

  // New function to handle Deploy Resources button click
  const handleDeployResources = () => {
    // Add incidentId to each object in fullResourcesData
    const resourcesWithIncidentId = fullResourcesData.map(resource => ({
      ...resource,
      incidentId: incidentId
    }));

    // Navigate with updated fullResourcesData that includes incidentId
    navigate("/resource-assign-list/deployment-resource", {
      state: {
        fullResourcesData: resourcesWithIncidentId,
      }
    });
    // toast.success("Resources Deployed successfully", {
    //   position: toast.POSITION.TOP_CENTER,
    //   autoClose: 2000,
    // });
  };

  function refreshTaskTable() {
    // getMyTaskList();
    setShowPop(false);
  }

  // Initialize fileObjs state
  const [fileObjs, setFileObjs] = useState([]);

  const tabsData = generateTabsData(CreateTaskConfig);

  // Clear session storage on unmount or when navigating away
  useEffect(() => {
    return () => {
      // Uncomment below if you want to clear the storage when leaving the page
      // sessionStorage.removeItem(SESSION_STORAGE_KEY);
    };
  }, []);

  if (!formData) {
    return <Loader show={true} type="body" stack="vertical" message="Loading Data" />;
  }

  return (
    <>
      <div className="mt-4">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />

        <div className="form-body">
          <div className="registration__form--body">
            <div className="sop-instance-table">
              <div className="row">
                <div className="col-sm-3">
                  <div className="sop_instance_info">ID</div>
                </div>
                <div className="col-sm-3">
                  <div className="sop_instance_info">Instance Name</div>
                </div>
                <div className="col-sm-3">
                  <div className="sop_instance_info">Status</div>
                </div>
                <div className="col-sm-3">
                  <div className="sop_instance_info">Incident</div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <div>{formData?.id || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div>{formData?.name || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div>{formData?.status || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div>{formData?.incident || "N/A"}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <div className="mt-3 sop_instance_info">Time</div>
                </div>
                <div className="col-sm-3">
                  <div className="mt-3 sop_instance_info">SOP Name</div>
                </div>
                <div className="col-sm-3">
                  <div className="mt-3 sop_instance_info">SOP Description</div>
                </div>
                <div className="col-sm-3">
                  <div className="mt-3 sop_instance_info"></div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <div>{formData?.created_on || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div>{formData?.sop || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div>{formData?.description || "N/A"}</div>
                </div>
                <div className="col-sm-3">
                  <div></div>
                </div>
              </div>

              {/* New Resources Row */}
              <div className="row mt-3">
                <div className="col-sm-12">
                  <div className="sop_instance_info">Resources</div>
                  <div className="mt-2 text-truncate" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {resourcesData}
                  </div>
                </div>
              </div>


              <div className="mt-4">
                <button
                  className={`btn ${formData?.status === "Closed"
                      ? "btn-closed-sop"
                      : "btn-close-sop"
                    }`}
                  style={{
                    backgroundColor:
                      formData?.status === "Closed" ? "green" : "blue",
                    border: "none"
                  }}
                  onClick={handleClickClose}
                  disabled={formData?.status !== "Completed"} // Button is enabled only when status is "Completed"
                >
                  {formData?.status === "Closed" ? "Closed" : "Close SOP"}
                </button>
                <button
                  className="btn btn-close-sops"
                  onClick={handleclickCancel}
                  disabled={
                    formData?.status !== "Started" && formData?.status !== "In-Progress"
                  }
                >
                  Cancel SOP
                </button>
                <button
                  className="btn"
                  onClick={handleDeployResources}
                  disabled={!resourcesData || resourcesData === "NA"}
                  style={{
                    backgroundColor: "#28a745",
                    border: "none",
                    padding: "7px 10px",
                    borderRadius: "0.25rem",
                    color: "white",
                    fontWeight: "200",
                    fontSize: "12px",
                    lineHeight: "1.5",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    verticalAlign: "middle",
                    cursor: "pointer",
                    height: "34px", // Match input field height
                    marginBottom: "16px",
                    marginTop: "16px",
                    marginLeft: "15px" // Match input field margin
                  }}
                >
                  Deploy Resources
                </button>

              </div>
              {showPop && (
                <TaskModalWithCommentSopCancel
                  titleValue={t("Cancel SOP Instance")}
                  show={showPop}
                  setShowPop={setShowPop}
                  taskData={formData}
                />
              )}
              {showConfirmPopup && (
                <ConfirmpopupSop
                  titleValue={t("Close SOP Instance")}
                  show={showConfirmPopup}
                  setshowConfirmPopup={setshowConfirmPopup}
                  taskData={formData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SopsInstanceForm;